import React from 'react';
import {
    AvatarOverlay,
    AvatarThirdsGrid,
    Background,
    CropContainer,
    EditorBackground,
    EditorImage,
    ThirdsGrid,
} from '../style';
import type { FitSizes } from '../types';
import type { BackgroundSelection, PreparedImage } from '../utils/convertImage';

export type EditorCanvasProps = {
    containerRef: React.RefObject<HTMLDivElement>;
    aspectRatio: number;
    avatar?: boolean;
    backgroundSelection: BackgroundSelection;
    imageData: PreparedImage | null;
    fitSizes: FitSizes;
    zoom: number;
    rotation: number;
    offset: { x: number; y: number };
    isRotating: boolean;
    showGrid?: boolean;
    onPointerDown: (event: React.PointerEvent<HTMLDivElement>) => void;
    onPointerMove: (event: React.PointerEvent<HTMLDivElement>) => void;
    onPointerUp: (event: React.PointerEvent<HTMLDivElement>) => void;
};

export const EditorCanvas: React.FC<EditorCanvasProps> = ({
    containerRef,
    aspectRatio,
    avatar = false,
    backgroundSelection,
    imageData,
    fitSizes,
    zoom,
    rotation,
    offset,
    isRotating,
    showGrid = true,
    onPointerDown,
    onPointerMove,
    onPointerUp,
}) => (
    <CropContainer
        ref={containerRef}
        aspectRatio={aspectRatio}
        avatar={avatar}
        onPointerDown={onPointerDown}
        onPointerLeave={onPointerUp}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
    >
        <EditorBackground>
            <Background
                isBlur={backgroundSelection.type === 'blur'}
                style={
                    backgroundSelection.type === 'blur'
                        ? {
                              backgroundImage: `url(${imageData?.src})`,
                          }
                        : {
                              background: backgroundSelection.color,
                          }
                }
            />
        </EditorBackground>
        {showGrid ? (
            avatar ? (
                <AvatarThirdsGrid />
            ) : (
                <ThirdsGrid />
            )
        ) : null}
        {avatar ? <AvatarOverlay /> : null}
        {imageData?.src && (
            <EditorImage
                alt=""
                draggable={false}
                isRotating={isRotating}
                src={imageData.src}
                style={{
                    width: fitSizes.baseWidth * zoom || 0,
                    height: fitSizes.baseHeight * zoom || 0,
                    transform: `translate(-50%, -50%) translate(${offset.x}px, ${offset.y}px) rotate(${rotation}deg)`,
                }}
            />
        )}
    </CropContainer>
);
